import { render, staticRenderFns } from "./GoodsBaseItem.vue?vue&type=template&id=734c525b&"
import script from "./GoodsBaseItem.vue?vue&type=script&lang=js&"
export * from "./GoodsBaseItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodsBaseItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports